import styled from 'styled-components';
import { colors } from '../../utils/styles/colors';

export const SpinnerContainer = styled.div`
  width: 95%;
  height: 85%;
  position: absolute;
  z-index: 100;
   display: flex;
  justify-content: center;
  align-items: center; 
  .loader,
  .loader:after {
    border-radius: 50%;
    width: 10em;
    height: 10em;
  }
  .loader {
    margin: auto auto;
    font-size: 10px;
    position: relative;
    text-indent: -9999em;
    border-top: 1.1em solid rgba(167,116,249, 0.2);
    border-right: 1.1em solid rgba(167,116,249, 0.2);
    border-bottom: 1.1em solid rgba(167,116,249, 0.2);
    border-left: 1.1em solid ${colors.hightlight};
    -webkit-transform: translateZ(0);
    -ms-transform: translateZ(0);
    transform: translateZ(0);
    -webkit-animation: load8 1.1s infinite linear;
    animation: load8 1.1s infinite linear;
  }
  @-webkit-keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
  @keyframes load8 {
    0% {
      -webkit-transform: rotate(0deg);
      transform: rotate(0deg);
    }
    100% {
      -webkit-transform: rotate(360deg);
      transform: rotate(360deg);
    }
  }
`